import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';

import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider, useTheme } from './context/ThemeContext';
import LoginPage from './pages/LoginPage';
import AuthCallback from './pages/AuthCallback';
import HomePage from './pages/HomePage';
import StudentsPage from './pages/StudentsPage';
import RecordsPage from './pages/RecordsPage';
import ReportsPage from './pages/ReportsPage';
import IntakesPage from './pages/IntakesPage';
import UsersPage from './pages/UsersPage';
import PermissionsPage from './pages/PermissionsPage';
import AuditPage from './pages/AuditPage';
import ScanPage from './pages/ScanPage';
import Layout from './components/Layout';
import SettingsPage from './pages/SettingsPage';

function ProtectedRoute({ children, module, action = 'view' }) {
  const { user, loading, can } = useAuth();
  if (loading) return <div className="d-flex justify-content-center align-items-center vh-100"><div className="spinner-border text-primary" /></div>;
  if (!user) return <Navigate to="/" replace />;
  if (module && !can(module, action)) return (
    <div className="container mt-5 text-center">
      <i className="bi bi-shield-x fs-1 text-danger" />
      <h4 className="mt-3">Access Denied</h4>
      <p className="text-muted">You don't have permission to view this page.</p>
    </div>
  );
  return children;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/" element={user ? <Navigate to="/home" replace /> : <LoginPage />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/scan/:qrId" element={<ScanPage />} />
      <Route path="/" element={<Layout />}>
        <Route path="home"        element={<ProtectedRoute module="home">       <HomePage />       </ProtectedRoute>} />
        {/* <Route path="students"    element={<ProtectedRoute module="students">   <StudentsPage />   </ProtectedRoute>} /> */}
        <Route path="records"     element={<ProtectedRoute module="records">    <RecordsPage />    </ProtectedRoute>} />
        <Route path="reports"     element={<ProtectedRoute module="reports">    <ReportsPage />    </ProtectedRoute>} />
        {/* <Route path="intakes"     element={<ProtectedRoute module="intakes">    <IntakesPage />    </ProtectedRoute>} /> */}
        <Route path="users"       element={<ProtectedRoute module="users">      <UsersPage />      </ProtectedRoute>} />
        <Route path="permissions" element={<ProtectedRoute module="permissions"><PermissionsPage /></ProtectedRoute>} />
        <Route path="settings"    element={<ProtectedRoute module="settings">   <SettingsPage />   </ProtectedRoute>} />
        <Route path="audit"       element={<ProtectedRoute module="audit">      <AuditPage />      </ProtectedRoute>} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function ThemedToastContainer() {
  const { theme } = useTheme();
  return (
    <ToastContainer position="top-right" autoClose={4000} hideProgressBar={false} newestOnTop closeOnClick pauseOnFocusLoss draggable pauseOnHover theme={theme} />
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <ThemedToastContainer />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}